export default "__VITE_ASSET__e9c8aabf__"